module.exports = __webpack_public_path__ + "img/service-card-6.6eabdc31.png";